import React from 'react';

import { Flex, Modal, ModalProps, Space, Stack, Text, Title } from '@mantine/core';

export interface DroxyModalProps extends ModalProps {
  titleIcon?: React.ReactNode;
  description?: string;
}

export function DroxyModal(droxyModalProps: DroxyModalProps) {
  const { opened, onClose, title, description, titleIcon, children, ...modalProps } = droxyModalProps;

  return (
    <Modal opened={opened} onClose={onClose} withCloseButton={false} {...modalProps}>
      <Modal.Header style={{ padding: 0 }}>
        <Stack w="100%" spacing={4}>
          <Flex justify="space-between">
            <Modal.Title>
              <Flex align="center" gap={6}>
                {titleIcon}
                <Title order={3}>{title}</Title>
              </Flex>
            </Modal.Title>
            <Modal.CloseButton />
          </Flex>
          <Text color="dimmed" size="sm">
            {description}
          </Text>
        </Stack>
      </Modal.Header>

      <Space h={16} />

      <Modal.Body style={{ padding: 0 }}>{children}</Modal.Body>
    </Modal>
  );
}
